import React from 'react';
import { TYPES, usersUtil } from 'services/utils/users-util';
import Button from 'components/shared/button/Button';
import PropTypes from 'prop-types';

export function ClientLinkButtons(props) {
  const handleViewBudget = (props) => {
    if (props.onBudgetClick) {
      props.onBudgetClick();
    }
  };

  const handleViewInvoice = (props) => {
    if (props.onInvoiceClick) {
      props.onInvoiceClick();
    }
  };

  const handleViewQuote = (props) => {
    if (props.onQuoteClick) {
      props.onQuoteClick();
    }
  };

  let content = null;
  if (usersUtil.hasType(props.user, TYPES.CLIENT)) {
    if (props.workOrder.invoice !== null) {
      content = (
        <Button
          className="button-orange"
          label="View Invoice"
          onClick={() => handleViewInvoice(props)}
        />
      );
    } else if (props.proposals.length > 0) {
      content = (
        <Button
          className="button-orange"
          label="View Quote"
          onClick={() => handleViewQuote(props)}
        />
      );
    } else if (props.budget !== null) {
      content = (
        <Button
          className="button-orange"
          label="View Estimate"
          onClick={() => handleViewBudget(props)}
        />
      );
    }
  }
  return content;
}

ClientLinkButtons.propTypes = {
  budget: PropTypes.shape(),
  proposals: PropTypes.array,
  user: PropTypes.shape().isRequired,
  workOrder: PropTypes.shape().isRequired,
  onBudgetClick: PropTypes.func,
  onInvoiceClick: PropTypes.func,
  onQuoteClick: PropTypes.func,
};

ClientLinkButtons.defaultProps = {
  budget: null,
  proposals: [],
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/ClientLinkButtons.js